module.exports = __webpack_public_path__ + "static/media/checklist-icon.63fb3bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Header/images/checklist-icon.png
// module id = 1588
// module chunks = 0